module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "polycanvas"
  }, [_c('div', {
    staticClass: "canvaswrap"
  }, [_c('svg', {
    staticClass: "canvas"
  }, [_c('g', {
    attrs: {
      "transform": "translate(0,400) scale(1,-1)"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.subpath,
      "stroke": "#3498db",
      "stroke-width": "1",
      "fill": "#fcfcfc",
      "fill-rule": "evenodd"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.clippath,
      "stroke": "#e74c3c",
      "stroke-width": "1",
      "fill": "#fcfcfc",
      "fill-rule": "evenodd"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": _vm.resultpath,
      "stroke": "#2c3e50",
      "stroke-width": "1",
      "fill": "#42b983",
      "fill-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'loading': _vm.calculating,
      'not-loading': !_vm.calculating
    }
  }, [_vm._v("\n        Loading\n    ")])]), _vm._v(" "), _c('h3', [_vm._v("Result")]), _vm._v(" "), _c('pre', {
    ref: "TEST",
    staticClass: "result language-json",
    domProps: {
      "innerHTML": _vm._s(_vm.result_html)
    }
  }, [_vm._v(">")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf04585e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolyCanvas.vue
// module id = 57
// module chunks = 0